// Shared by a ticket and its items so replacement rows retain protection from
// compatibility mouse events. Real touch gestures never pass through this gate.
export function isCompatibilityMouseEvent(event, touchState) {
  const native = event?.nativeEvent || event;
  const fromTouch = native?.sourceCapabilities?.firesTouchEvents;
  if (fromTouch === false) return false;
  return fromTouch === true || Date.now() < (touchState?.suppressUntil || 0);
}
